import React from "react";

import { MDBAnimation } from "mdbreact";
export const Member = (props) => {
  return (
    <a className="card1" href="#!">
      <div className="front">
        <MDBAnimation
          reveal
          type="fadeInDownBig"
          duration="1500ms"
          delay="0.3s"
        >
          <p>{props.name}</p>
        </MDBAnimation>
      </div>
      <div className="back">
        <div>
          <p>{props.para1}</p>
          <p>{props.para2}</p>
          <button className="button">{props.btn}</button>
        </div>
      </div>
    </a>
  );
};
